module.exports = __webpack_public_path__ + "images/toolbox.2bbf519b.svg";